import apiService from "../../api/api.service";
import { GetCampaignResponse, GetCampaignsResponse } from "./campaign.types";
import { FilterRequest } from "../filters/filters.types";

export const fetchCampaigns = (page: number = 1): Promise<GetCampaignsResponse> => {
  return apiService.get<GetCampaignsResponse>("/promotions/campaigns", { params: { page } });
};

export const fetchCampaign = async (
  code: string,
  page?: number,
  filters?: Partial<FilterRequest>,
): Promise<GetCampaignResponse> => {
  const { section_id, seque, ...rest } = filters ?? {};
  const filtersClean = Object.fromEntries(
    Object.entries(rest).filter(([, v]) => v !== undefined),
  );
  const params = {
    ...(page ? { page } : {}),
    ...(section_id !== undefined ? { section_id } : {}),
    ...(seque !== undefined ? { seque } : {}),
    ...(Object.keys(filtersClean).length ? { filters: filtersClean } : {}),
  };
  return apiService.get<GetCampaignResponse>(
    `/promotions/campaigns/${code}`,
    Object.keys(params).length ? { params } : undefined,
  );
};